import React, { ReactNode } from 'react'
import HomeIcon from '@mui/icons-material/Home'
import EventIcon from '@mui/icons-material/Event'
import ExitToAppIcon from '@mui/icons-material/ExitToApp'
import PermDataSettingIcon from '@mui/icons-material/PermDataSetting'

const PageRouteAndIcon = (route: string, icon: ReactNode) => ({
  route: route,
  icon: icon,
})

const ExternalNavRoutes = {
  Home: PageRouteAndIcon('/', <HomeIcon />),
  Events: PageRouteAndIcon('/events', <EventIcon />),
  'Pre-Item Setup': PageRouteAndIcon('/item-setup', <PermDataSettingIcon />),
  Logout: PageRouteAndIcon('/logout', <ExitToAppIcon />),
}

export default ExternalNavRoutes
